module.exports = __webpack_public_path__ + "img/shuicao3.e1966d6f.gif";